<script setup>
defineProps(["class"]);
</script>

<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M15 3H21V9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="square"
            stroke-linejoin="miter"
        />
        <path
            d="M9 21H3V15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="square"
            stroke-linejoin="miter"
        />
        <path
            d="M21 3L14 10"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="square"
        />
        <path
            d="M3 21L10 14"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="square"
        />
    </svg>
</template>
